import 'bootstrap';

function handleVideoModalEvents(): void {
  const videoModalElement = document.getElementById('videoModal');
  const videoModalContentElement = document.getElementById('videoModalContent');
  const videoModalLabelElement = document.getElementById('videoModalLabel');

  if (videoModalElement && videoModalContentElement) {
    videoModalElement.addEventListener('show.bs.modal', (event: Event & { relatedTarget: HTMLElement }) => {
      const relatedTarget = event.relatedTarget;
      if (relatedTarget) {
        const iframeTitle = relatedTarget.dataset.videoTitle || 'Vidyard video player';
        videoModalContentElement.innerHTML = `<iframe src="https://play.vidyard.com/${relatedTarget.dataset.videoVidyardId}?disable_popouts=1&v=4.3.15&type=lightbox" title="${iframeTitle}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
        videoModalLabelElement.innerHTML = relatedTarget.attributes['aria-label'].value
      }
    });

    videoModalElement.addEventListener('hidden.bs.modal', () => {
      videoModalContentElement.innerHTML = '';
      videoModalLabelElement.innerHTML = '';
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  handleVideoModalEvents();
});
